// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {type FC, Fragment} from 'react';

import {
  createDismissibleBanner,
  DEFAULT_BANNER_SHOW_AFTER,
} from '../../../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {
  AccountStatusBanner,
  AccountStatusBannerBoldText,
  AccountStatusBannerFlexWrapper,
  AccountStatusBannerTextWrapper,
} from '../../AccountStatusBanner';
import {useCurrentBannerStates} from '../useCurrentBannerStates';
import {type WeaveApproachingLimitBannerProps} from './types';

export const WeaveApproachingLimitBannerGlobalList: FC = () => {
  const currentBannerStates = useCurrentBannerStates();
  return (
    <Tailwind>
      <div className="space-y-8">
        {currentBannerStates.map(state => {
          const weaveApproachingLimitBannerProps =
            state.weaveEnforcementBannerFlags.weaveApproachingLimitBannerProps;
          return (
            <Fragment key={state.account.name + state.account.accountType}>
              {weaveApproachingLimitBannerProps && (
                <WeaveApproachingLimitBanner
                  {...weaveApproachingLimitBannerProps}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </Tailwind>
  );
};

export const WeaveApproachingLimitBanner =
  createDismissibleBanner<WeaveApproachingLimitBannerProps>({
    id: ({organizationId}) => {
      return `weave-approaching-limit-banner-${organizationId}`;
    },
    showAfter: DEFAULT_BANNER_SHOW_AFTER,
    Component: ({
      organizationId,
      approachingLimitBoldText,
      approachingLimitStatusMsg,
      approachingLimitCTA,
      planName,
    }) => {
      return (
        <Tailwind>
          <AccountStatusBanner
            eventData={{
              location: `exceeded 90% for Weave alert banner`,
              organizationId,
              resource: 'Weave',
              planName,
            }}>
            <AccountStatusBannerFlexWrapper>
              <div>
                <Icon name="info" />
              </div>
              <AccountStatusBannerTextWrapper>
                <span>
                  <AccountStatusBannerBoldText>
                    {approachingLimitBoldText}
                  </AccountStatusBannerBoldText>{' '}
                  <span>{approachingLimitStatusMsg}</span>
                </span>
              </AccountStatusBannerTextWrapper>
              {approachingLimitCTA}
            </AccountStatusBannerFlexWrapper>
          </AccountStatusBanner>
        </Tailwind>
      );
    },
  });
